import React from "react";
import { useNavigate } from "react-router-dom";

/* comp imports */
import PageTransition from "../components/PageTransition";
import BackArrow from "../components/BackArrow";
import TowerGame from "./TowerGame";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

// import { preloadImages } from "../utils/preloadImages";
// import { allPicnicGameImages } from "./game-data/allPicnicGameImages";

const TowerGameWrapper = () => {
  const navigate = useNavigate();
  //   const [imagesLoaded, setImagesLoaded] = useState(false);
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };

  //   useEffect(() => {
  //     const images = preloadImages(allPicnicGameImages);
  //     let loadedCount = 0;

  //     images.forEach((img) => {
  //       img.onload = img.onerror = () => {
  //         loadedCount++;
  //         if (loadedCount === images.length) {
  //           setImagesLoaded(true);
  //         }
  //       };
  //     });
  //   }, []);

  //   if (!imagesLoaded) {
  //     return (
  //       <>
  //         <div className="loading-assets-screen">
  //           <div className="text-loader">
  //             <span>Loading</span>
  //             <span>Game</span>
  //             <span>Assets</span>
  //             <span>...</span>
  //           </div>
  //         </div>
  //       </>
  //     );
  //   }

  return (
    <>
      <PageTransition />
      <BackArrow handleRedirect={handleRedirect} linkName="/games" />
      <TowerGame handleRedirect={handleRedirect} />
      <MainDisclaimerModal />
    </>
  );
};

export default TowerGameWrapper;
